/**
 * Draft-pending notice — shown once per master per session to anyone who can
 * publish, when they open a spec that has a draft awaiting approval.
 * Esc / overlay = "View published". One primary: "Open draft".
 */
import React from 'react';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '../components/ui/dialog';
import { Button } from '../components/ui/button';

interface DraftPendingDialogProps {
  open: boolean;
  /** Who is in the draft right now, when known. */
  who: string | null;
  onViewPublished: () => void;
  onOpenDraft: () => void;
}

export function DraftPendingDialog({
  open,
  who,
  onViewPublished,
  onOpenDraft,
}: DraftPendingDialogProps) {
  const openDraftRef = React.useRef<HTMLButtonElement>(null);
  return (
    <Dialog
      open={open}
      onOpenChange={(o) => {
        if (!o) onViewPublished();
      }}
    >
      <DialogContent
        hideClose
        onOpenAutoFocus={(e) => {
          e.preventDefault();
          openDraftRef.current?.focus();
        }}
      >
        <DialogHeader>
          <DialogTitle>Draft changes awaiting publish</DialogTitle>
          <DialogDescription>
            Draft changes have been made to this spec and are awaiting approval for publish.
          </DialogDescription>
        </DialogHeader>
        {who && <p className="text-sm text-muted">In the draft: {who}</p>}
        <DialogFooter>
          <Button variant="secondary" onClick={onViewPublished}>
            View published
          </Button>
          <Button ref={openDraftRef} onClick={onOpenDraft}>
            Open draft
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
